import Overview from "@/components/admin/Content/WebPages/AboutUs/OurHistory/Overview";
import HeroSection from "@/components/admin/Content/WebPages/AboutUs/OurHistory/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const OurHistory = () => {
    const { pageData, isLoading } = useWebPageForm();
  
    if (isLoading) {
        return <FullPageSpinner />
    }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      {pageData?.OUR_HISTORY_BANNER && <HeroSection data={pageData.OUR_HISTORY_BANNER} />}
      {pageData?.OUR_HISTORY && <Overview data={pageData.OUR_HISTORY} />}
    </div>
  )
}

export default OurHistory